/**
 * Replaces placeholders in a template string with values from an object, and returns the result.
 *
 * Placeholders are in the form `{|name|}` where `name` is the key in the provided object.
 * @param {string} str String with placeholders.
 * @param {Record<string, string>} values Object with values for the placeholders.
 * @returns {string} String with placeholders replaced with values from the object.
 * @example
 * const msg = template('Hello {|username|}! {|username|} is awesome!', {
 *   username: 'Bob'
 * });
 *
 * // 'Hello Bob! Bob is awesome!'
 */
export const template = (str, values) => str.replace(/{\|\s*(.*?)\s*\|}/g, (match, value) => values[value] ?? match);
